import { useMediaQuery } from "react-responsive"
import { Link } from "react-router-dom"

const HLink = (props) => {

    const { id, path, pathname, fClick, fMouseEnter, fMouseLeave, fFocus, fBlur, fKeyDown, expanded, triggerRef, isBlue, isWhite, isLink, text } = props
    const isMobile = useMediaQuery({ maxWidth: 1280 })

    const shared = {
        id: id || undefined,
        ref: triggerRef || undefined,
        onClick: fClick || undefined,
        onMouseEnter: fMouseEnter || undefined,
        onMouseLeave: fMouseLeave || undefined,
        onFocus: fFocus || undefined,
        onBlur: fBlur || undefined,
        onKeyDown: fKeyDown || undefined,
    }

    const renderTrigger = (className) =>
        isLink
            ? <Link {...shared} to={path} className={className}>{text}</Link>
            : <button type="button" {...shared} aria-haspopup="true" aria-expanded={!!expanded} className={className}>{text}</button>

    if (isMobile)
        return (
            (isBlue) ?
                renderTrigger((pathname?.includes(path)) ? "header-link-blue-mobile-selected" : "header-link-blue-mobile")
                :
                renderTrigger((pathname?.includes(path)) ? "header-link-mobile-selected" : "header-link-mobile")
        )
    else
        return (
            (isWhite) ?
                <article className="header-subsection-item">
                    {renderTrigger((pathname?.includes(path)) ? "header-link-white-selected" : "header-link-white")}
                </article> :
                renderTrigger((pathname?.includes(path)) ? "header-link-selected" : "header-link")
        )

}

export default HLink
